import { Injectable } from '@angular/core';
import { GRANTED, REJECTED } from '@careapp-group/core';
import { PermissionRequestUpdateDto, PermissionsService } from '@careapp-group/ng-sdk';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { of } from 'rxjs';
import { catchError, map, switchMap, withLatestFrom } from 'rxjs/operators';
import * as actions from '../actions';
import { CAAction } from '../actions';
import { auth } from '../auth/auth.selectors';
import * as selectors from '../reducers';
import { TenantSelectors } from '../tenants/tenants.selectors';

@Injectable()
export class RequestsEffects {
  getRequests = createEffect(() =>
    this.actions$.pipe(
      ofType(actions.Requests.REQUEST_ALL),
      withLatestFrom(
        this.store.select(selectors.getSelectedId(selectors.ORGANISATIONS)),
        this.store.select(TenantSelectors.getSelectedId),
        this.store.select(auth.getLoggedInUser),
        this.store.select(selectors.org.currentOrgRoles),
      ),
      switchMap(([action, orgId, tenantId, user, roles]) => {
        return this.permissionsService.listRequests({ organisationId: orgId, tenantId }).pipe(
          map((requests) => actions.Requests.ResponseSuccessAllAction(requests)),
          catchError((err) => of(actions.Requests.ResponseFailAllAction(err))),
        );
      }),
    ),
  );

  handleAction = createEffect(() =>
    this.actions$.pipe(
      ofType(actions.Requests.REQUEST_APPROVE_REQUEST, actions.Requests.REQUEST_DENY_REQUEST),
      withLatestFrom(
        this.store.select(selectors.getSelectedId(selectors.ORGANISATIONS)),
        this.store.select(auth.getLoggedInUser),
        this.store.select(selectors.org.currentOrgRoles),
      ),
      switchMap(([action, orgId, user, roles]) =>
        this.permissionsService
          .updateRequest({
            id: action.payload.id,
            permissionRequestUpdateDto: {
              status: action.type === actions.Requests.REQUEST_APPROVE_REQUEST ? GRANTED : REJECTED,
            } as PermissionRequestUpdateDto,
          })
          .pipe(
            map((request) => actions.Requests.ResponseSuccessRespondAction(request)),
            catchError((err) =>
              of(
                actions.Requests.ResponseFailRespondAction({
                  error: err,
                  id: action.payload.id,
                }),
              ),
            ),
          ),
      ),
    ),
  );

  constructor(
    private actions$: Actions<CAAction>,
    private permissionsService: PermissionsService,
    private store: Store<any>,
  ) {}
  action: CAAction; // lint
}
